// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".article-card__hero[data-v-756a5fca]{height:200px;left:0;position:absolute;top:0;width:100%}.article-card__content--inset[data-v-756a5fca]{margin-top:200px}.article-card__modal[data-v-756a5fca]{max-width:100%}.article-card .clock-icon[data-v-756a5fca]{margin-top:-4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
